module.exports = __webpack_public_path__ + "static/media/more-brown.21033131.png";